import React from 'react'
import classnames from 'classnames/bind'
import type { AutomationTarget, SlottableComponent } from '../../../types'
import CardContainer, {
  CardContainerProps,
} from '../../elementals/cardContainer'
import styles from './styles.scss'
const cx = classnames.bind(styles)

/**
 * Basic layout for a header card
 * Supports slots for left, right, and lower content
 * Pass through CardContainer props to style the card
 */
interface HeaderCardProps
  extends AutomationTarget,
    SlottableComponent<'left' | 'right' | 'lower'> {
  className?: string
  style?: React.CSSProperties
  cardProps?: Omit<CardContainerProps, 'children' | 'slots'>
  gap?: 'small' | 'medium' | 'large' | 'x-large'
}

const HeaderCard: React.FC<HeaderCardProps> = ({
  className,
  style,
  slots,
  cardProps,
  gap = 'medium',
}) => (
  <CardContainer
    {...cardProps}
    className={cx('header-card', className)}
    style={style}
  >
    <div className={cx('upper', `gap-${gap}`)}>
      {slots?.left ? <div className={cx('left')}>{slots.left()}</div> : null}
      {slots?.right ? <div className={cx('right')}>{slots.right()}</div> : null}
    </div>
    {slots?.lower ? <div className={cx('lower')}>{slots.lower()}</div> : null}
  </CardContainer>
)

export default HeaderCard
